import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.seller}pricingPlanState/advanced/activate`;

const activateAdvancedPricingPlanCommand = async ({
  sellerId,
}: {
  sellerId: string;
}): Promise<BackResponseFailure | BaseBackResponse> => {
  try {
    return await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.PUT,
      json: { sellerId },
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default activateAdvancedPricingPlanCommand;
